import React from 'react'

const ExperienceCard = ({ data }) => {
  return (
    <li className="experience-item">
      <span className="experience-item__dot" aria-hidden="true" />
      <article className="experience-item__card">
        <div className="experience-item__top">
          <img
            className="experience-item__logo"
            src={data.companylogo}
            alt=""
          />
          <div className="experience-item__heading">
            <div className="experience-item__company-row">
              <h5 className="experience-item__company">{data.company}</h5>
              <span className="experience-item__date">{data.date}</span>
            </div>
            <p className="experience-item__role">{data.role}</p>
          </div>
        </div>
        {data.desc ? (
          <p className="experience-item__desc">{data.desc}</p>
        ) : null}
        {data.impact && data.impact.length ? (
          <ul className="experience-item__impact">
            {data.impact.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        ) : null}
        {data.tech && data.tech.length ? (
          <div className="experience-item__tech">
            {data.tech.map((item) => (
              <span className="experience-item__chip" key={item}>
                {item}
              </span>
            ))}
          </div>
        ) : null}
      </article>
    </li>
  )
}

export default ExperienceCard
